import React, { useState } from "react";

import "./App.scss";
import HeroBlock from "./components/heroBlock/HeroBlock";
import ConstructionBlock from "./components/constructionBlock/ConstructionBlock";
import ProjectBlock from "./components/projectBlock/ProjectBlock";
import ContactBlock from "./components/contactBlock/ContactBlock";
import Navbar from "./components/navbar/Navbar";
import Footer from "./components/footer/Footer";

import About from "./components/aboutBlock/About";

import UserContext from "./languages/UserContext";
import emailjs from "@emailjs/browser";
function App() {
  const [langHook, setLangHook] = useState("pl");
  emailjs.init("dh680qjjcTiFjyz6L");

  const changeLanguage = (e) => {
    setLangHook(`${e.target.textContent}`);
  };
  const language = {
    lang: langHook,
  };

  return (
    <UserContext.Provider value={language}>
      <div className="dreamhouse">
        <Navbar changeLanguageFunction={changeLanguage}></Navbar>
        <HeroBlock></HeroBlock>
        <About></About>
        <ProjectBlock></ProjectBlock>
        <ConstructionBlock></ConstructionBlock>
        <ContactBlock></ContactBlock>
        <Footer></Footer>
      </div>
    </UserContext.Provider>
  );
}

export default App;
